module.exports = __webpack_public_path__ + "static/img/new-20.c164d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-20.png
// module id = XQW0
// module chunks = 0